import { TrendingUp, Bot, LifeBuoy, Cpu } from "lucide-react";

const reasons = [
  {
    icon: TrendingUp,
    title: "A Business That Looks the Part",
    desc: "Clients judge you in seconds. We make you look established, professional, and worth paying — so more visitors become customers.",
  },
  {
    icon: Bot,
    title: "Automation That Pays for Itself",
    desc: "Apps that take repetitive work off your plate — ordering, scheduling, intake, follow-ups — so your team focuses on the work that matters.",
  },
  {
    icon: LifeBuoy,
    title: "Support With a Clear Pecking Order",
    desc: "No vague promises. Each tier has a defined priority level, and Tier 3 gets 24/7 support, always first in line. You know exactly where you stand.",
  },
  {
    icon: Cpu,
    title: "Modern Tech, Managed Forever",
    desc: "We build on current, fast, secure technology — and keep it that way with ongoing updates and full management. Your platform never ages out.",
  },
];

export default function WhyGsoftware() {
  return (
    <section id="why" className="relative border-t border-white/5 bg-[#050505] py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-[0.9fr_1.1fr] lg:px-10">
        <div>
          <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#ff003c]">// Why Gsoftware</p>
          <h2 className="font-display mt-4 text-3xl font-black leading-tight tracking-tight sm:text-4xl">
            We don't sell websites.
            <br />
            We sell <span className="text-[#00f0ff] text-glow-cyan">outcomes</span>.
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-white/50 md:text-lg">
            Better-looking businesses. Automated workflows. Reliable ongoing support.
            That's what a Gsoftware subscription actually buys.
          </p>
          <div className="mt-10 border-l-2 border-[#ff003c] pl-6">
            <p className="font-display text-lg font-bold leading-snug text-white/85">
              "Your competitors already look professional online. We make sure you look better — and run faster."
            </p>
          </div>
        </div>

        <div className="grid gap-6 sm:grid-cols-2">
          {reasons.map((r, i) => (
            <article
              key={r.title}
              data-testid={`why-card-${i + 1}`}
              className="group border border-white/10 bg-[#0a0a0a] p-8 transition-colors duration-300 hover:border-[#00f0ff]/35"
            >
              <r.icon size={26} className="text-[#00f0ff] transition-colors duration-300 group-hover:text-[#ff003c]" strokeWidth={1.5} />
              <h3 className="font-display mt-5 text-sm font-bold leading-snug">{r.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/50">{r.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
